import {useAppSelector} from "../../../../../redux/store";
import {BarekamIcon, IconVariants} from "../../../../components/icon/barekam-icon";
import BarekamButton, {SimpleButtons} from "../../../../components/button";
import {FilterOpened} from "../styled";
import BarekamText from "../../../../components/text";
import {Message, MessageSections} from "../../../../components/message/message";
import DateFilter from "./blocks/date-filter/date-filter";
import {useState} from "react";
import CollectionFilter from "./blocks/collection-filter/collection-filter";
import {HistoryFilterModel} from "../../../../shared/models/order/history-filter.model";
import OperationTypeFilter from "./blocks/operation-type-filter/operation-type-filter";

export const HistoryFilter = ({onFilterChange, mobileFilterOpened, setMobileFilterOpened}: HistoryFilterProps) => {
    const [filter, setFilter] = useState<HistoryFilterModel>({} as HistoryFilterModel);
    const {matchesPhone} = useAppSelector(state => state.deviceReducer);

    function handleFilterChange(field: 'collectionName' | 'updatedFields' | 'operationType' | 'startDate' | 'endDate' | 'userIdentity' | 'orderIdentity', value: any) {
        const modifiedFilter: HistoryFilterModel = {...filter};

        switch (field) {
            case "startDate":
            case "endDate":
                const dates = value as any[];

                if (dates.length === 1) {
                    modifiedFilter.startDate = new Date(dates[0]).getTime();
                    modifiedFilter.endDate = new Date(dates[0].add(1, 'day')).getTime();
                } else if (dates.length === 2) {
                    modifiedFilter.startDate = new Date(dates[0]).getTime();
                    modifiedFilter.endDate = new Date(dates[1]).getTime();
                } else {
                    delete modifiedFilter.startDate;
                    delete modifiedFilter.endDate;
                }
                break;
            default:
                if (value) {
                    modifiedFilter[field] = value;
                } else {
                    delete modifiedFilter[field];
                }
        }

        setFilter(modifiedFilter);
        onFilterChange(modifiedFilter);
    }

    function resetFilter() {
        setFilter({});
        onFilterChange({});

        setMobileFilterOpened(false);
    }

    const FilterResetButton = () => {
        return (
            <BarekamButton type={SimpleButtons.LINK} onClick={() => resetFilter()}>
                <BarekamIcon variant={IconVariants.reset}/>

                <BarekamText variant={'m'} bold color={'#A9A9C2'}>
                    <Message messageKey={"reset"} sectionId={MessageSections.ORDERS}/>
                </BarekamText>
            </BarekamButton>
        )
    }

    const FilterContent = () => {
        return (
            <>
                <CollectionFilter selectedCollection={filter.collectionName}
                                  onFilterChange={data => handleFilterChange('collectionName', data)}/>

                <DateFilter minEnteredDate={filter.startDate}
                            maxEnteredDate={filter.endDate}
                            onFilterChange={data => handleFilterChange('startDate', data)}/>

                <OperationTypeFilter operation={filter.operationType}
                                     onFilterChange={data => handleFilterChange('operationType', data)}/>

                {Object.keys(filter).length > 0
                    ? <FilterResetButton/>
                    : ''
                }
            </>
        )
    }

    // TODO: mobile filter not implemented
    // if (matchesPhone) {
    //     return (
    //         <FilterDialog open={mobileFilterOpened} onClose={() => setMobileFilterOpened(false)}>
    //             <FilterOpenedMobile>
    //                 <FilterContent/>
    //             </FilterOpenedMobile>
    //         </FilterDialog>
    //     )
    // } else {
        return (
            <FilterOpened>
                <FilterContent/>
            </FilterOpened>
        )
    // }
}

interface HistoryFilterProps {
    onFilterChange: (filter: HistoryFilterModel) => void,
    mobileFilterOpened: boolean,
    setMobileFilterOpened: React.Dispatch<React.SetStateAction<boolean>>
}